import {
  IStatementColumns,
  IStatementLine,
  langauge,
  StatementColumns,
  toDecimal,
} from "shared";

import { toCsv } from "../../../../main/components/EmailPerformance/stats";

type Cell = string | number | null;

const typeLabels: Record<string, string> = {
  invoice: `Invoice`,
  paid_invoice: `Invoice`,
  credit_note: `Credit Note`,
  overpayment: `Overpayment`,
  prepayment: `Prepayment`,
  payment: `Payment`,
  credit_note_refund: `Credit Note Refund`,
  prepayment_refund: `Prepayment Refund`,
  overpayment_refund: `Overpayment Refund`,
  opening_balance: `Opening Balance`,
};

function cell(line: IStatementLine, column: StatementColumns | string): Cell {
  switch (column) {
  case StatementColumns.Activity: return line.invoiceNumber;
  case StatementColumns.Reference: return line.invoiceReference ?? ``;
  case StatementColumns.Date: return line.issueDateString;
  case StatementColumns.DueDate: return line.invoiceDueDateString ?? ``;
  case StatementColumns.PaidDate: return line.paidDateString ?? ``;
  case StatementColumns.OverdueAge: return line.debtAgeInDays ?? ``;
  case StatementColumns.Amount: return toDecimal(line.totalInCents);
  case StatementColumns.NetAmount: return toDecimal(line.subTotalInCents);
  case StatementColumns.Payments: return toDecimal(line.paymentsInCents);
  case StatementColumns.Balance: return toDecimal(line.outstandingInCents);
  case StatementColumns.Tax: return toDecimal(line.totalTaxInCents);
  case StatementColumns.QBOPrivateNote: return line.qboPrivateNote ?? ``;
  case StatementColumns.PromptPaymentDiscountAmount:
    return line.totalPaidniceDiscountInCents ? toDecimal(line.totalPaidniceDiscountInCents) : ``;
  // Custom invoice field
  default: return line.childInvoiceFields?.find(f => f.name === column)?.value ?? ``;
  }
}

/** Builds a CSV of statement lines using the portal's column settings */
export function statementToCsv(lines: IStatementLine[], columns: IStatementColumns, includeContact: boolean) {
  const headings = columns.map(c => c.label || langauge.settings.statement.statementColumnSettings[c.type]?.label || c.type);

  return toCsv([
    [`Type`, ...(includeContact ? [`Contact`] : []), ...headings],
    ...lines.map(line => [
      typeLabels[line.type] ?? line.type,
      ...(includeContact ? [line.contactName ?? ``] : []),
      ...columns.map(c => cell(line, c.type)),
    ]),
  ]);
}
